import { type PropsWithChildren } from "react"

interface ButtonProps extends PropsWithChildren {
  className?: HTMLButtonElement["className"]
  type?: HTMLButtonElement["type"]
}

export const Button = ({ className, ...props }: ButtonProps) => (
  <button
    className={`h-[32px] w-[84px] rounded-[3px] text-[0.75rem] ${className ?? ""}`}
    {...props}
  />
)

export const LoadingButton = ({ className, ...props }: ButtonProps) => (
  <Button
    className={`w-[32px] bg-brand-primary pt-[3px] text-white hover:bg-brand-secondary ${className ?? ""}`}
    {...props}
  />
)
